// Every symbol the API uses for a US venue. It reports Nasdaq listings as
// `Nasdaq` or by tier (`NasdaqGS`/`NasdaqGM`/`NasdaqCM`), and not always the same
// one for the same stock, so a list with only `Nasdaq` treated Apple as non-US
// (no options in the page title, the non-US order-book feed). Exact-case
// `.includes` callers rely on these spellings; prefer `isUsExchange`.
export const usExchanges = ["ARCA", "NYSEArca", "Nasdaq", "NasdaqGS", "NasdaqGM", "NasdaqCM", "NYSE", "NYSEAM", "AMEX", "BATS"];

/** True when `exchange` is a US venue symbol, in any case. */
export const isUsExchange = (exchange: string | null | undefined): boolean => !!exchange && usExchanges.some((symbol) => symbol.toLowerCase() === exchange.toLowerCase());
